import React, { lazy } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { BaseLayout } from './components/layout/layout';
import { ErrorPage } from './error-page';
import PercelenOld from 'pages/bodem-en-gewas/percelen-old';
// Pages
const HomePage = lazy(() => import('./pages/home'));
const BeheerAlgemeen = lazy(() => import('./pages/beheer/algemeen/beheer-algemeen'));
const PilotBeheerHome = lazy(() => import('./pages/beheer/pilots-beheren'));
const DataproductenHome = lazy(() => import('./pages/beheer/dataproducten'));
const BeheerDataKoppelingen = lazy(() => import('./pages/beheer/datakoppelingen'));
const AkkerbouwPage = lazy(() => import('./pages/bodem-en-gewas/akkerbouw'));
const Broker = lazy(() => import('./pages/beheer/broker'));
const Deelnemers = lazy(() => import('./pages/deelnemers'));
const JongveePage = lazy(() => import('./pages/dier/melk-jongvee/jongvee-page'));
const Meststromen = lazy(() => import('./pages/mest/meststromen'));
const OrganischeMest = lazy(() => import('./pages/mest/organisch-mest'));
const MestAdditief = lazy(() => import('./pages/mest/mest-additief'));
const OrganischeMestVerbruik = lazy(() => import('./pages/mest/organisch-mest-verbruik'));
const SBDashboard = lazy(() => import('./pages/beheer'));
const BerichtstromenBeheren = lazy(() => import('./pages/beheer/berichtstromen-beheren'));
const BedrijfsGegevens = lazy(() => import('./pages/bedrijfsgegevens'));
const RapportageDashboard = lazy(() => import('./pages/rapportage'));
const HistorischRapportageDashboard = lazy(() => import('./pages/rapportage/historisch'));
const ImportberichtenOpnieuwVerwerken = lazy(() => import('./pages/beheer/importberichten-opnieuw-verwerken'));
const ApprovedParticipations = lazy(() => import('./pages/beheer/machtiging/approved-participations'));
const ManageParticipations = lazy(() => import('./pages/beheer/machtiging/manage-participations'));
const ManagePurposes = lazy(() => import('./pages/beheer/machtiging/manage-purposes'));
const Mandates = lazy(() => import('./pages/beheer/machtiging/mandates'));
const RevokedParticipations = lazy(() => import('./pages/beheer/machtiging/revoked-participations'));
const UnApprovedParticipations = lazy(() => import('./pages/beheer/machtiging/unapproved-participations'));
const BeheerRapportage = lazy(() => import('./pages/beheer/rapportage/rapportage-dashboard'));
const BodemOverig = lazy(() => import('./pages/bodem-en-gewas/bodem-overig/index'));
const BodemAnalyses = lazy(() => import('./pages/bodem-en-gewas/bodem-analyses/index'));
const BodemOverzicht = lazy(() => import('./pages/bodem-en-gewas/bodem-overzicht'));
const Percelen = lazy(() => import('./pages/bodem-en-gewas/percelen/index'));
const PercelenOpKaartPage = lazy(() => import('./pages/bodem-en-gewas/percelen-op-kaart/index'));
const Grasland = lazy(() => import('./pages/Voer/grasland/grasland'));
const Krachtvoer = lazy(() => import('./pages/Voer/krachtvoer/krachtvoer'));
const Melk = lazy(() => import('./pages/Voer/melk/melk'));
const Overige = lazy(() => import('./pages/Voer/overige/overige'));
const Ruwvoer = lazy(() => import('./pages/Voer/ruwvoer/ruwvoer'));
const Snijmais = lazy(() => import('./pages/Voer/snijmais/snijmais'));
const Strooisel = lazy(() => import('./pages/Voer/strooisel/strooisel'));
const Signaleringen = lazy(() => import('./pages/signaleringen'));
const Koppelingen = lazy(() => import('./pages/koppelingen'));
const RelatieRegistratie = lazy(() => import('./pages/beheer/relatie-registratie'));
const Intensief = lazy(() => import('pages/dier/intensieve-veehouderij/Intensief'));
const Profiel = lazy(() => import('./pages/profiel/index'));
const RelatieStatus = lazy(() => import('./pages/relatie-status'));
const Energie = lazy(() => import('./pages/energie'));
const EnergieTransacties = lazy(() => import('./pages/energie-transacties'));
const Kunstmest = lazy(() => import('./pages/mest/kunstmest'));
const KunstmestVerbruik = lazy(() => import('./pages/mest/kunstmest-verbruik'));
const BVROverzicht = lazy(() => import('./pages/boervriendelijke-rapportage/overzicht'));
const BVREiwitEigenLand = lazy(() => import('./pages/boervriendelijke-rapportage/eiwit-eigen-land'));
const BVRAmmoniak = lazy(() => import('./pages/boervriendelijke-rapportage/ammoniak'));
const BVRBroeikasgassenMeetmelk = lazy(() => import('./pages/boervriendelijke-rapportage/broeikasgassen-meetmelk'));
const BVRStikstofBodemOverschot = lazy(() => import('./pages/boervriendelijke-rapportage/stikstof-bodem-overschot'));
const BVRRuwEiwitPerKvem = lazy(() => import('./pages/boervriendelijke-rapportage/ruw-eiwit-per-kvem'));
const BVRRuwEiwitInRantsoen = lazy(() => import('./pages/boervriendelijke-rapportage/ruw-eiwit'));
const BVRKrachtvoerPerLMelk = lazy(() => import('./pages/boervriendelijke-rapportage/krachtvoer-per-L-melk'));
const BVRBexVoordeel = lazy(() => import('./pages/boervriendelijke-rapportage/bex-voordeel'));
const BVRBroeikasgassenPerBedrijf = lazy(() => import('./pages/boervriendelijke-rapportage/broeikasgassen-per-bedrijf'));
const BVRVeestapel = lazy(() => import('./pages/boervriendelijke-rapportage/veestapel'));
const BVRGrondEnGewassen = lazy(() => import('./pages/boervriendelijke-rapportage/grond-en-gewassen'));
const KengetallenTool = lazy(() => import('./pages/kengetallen-tool'));
const MelkLevering = lazy(() => import('./pages/dier/melk-levering/MelkLevering'));
const MaintenancePage = lazy(() => import('./pages/maintenance'));

const router = createBrowserRouter([
  {
    path: '/maintenance',
    element: <MaintenancePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '',
    element: <BaseLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/approved-participations',
        element: <ApprovedParticipations />,
      },
      {
        path: '/unapproved-participations',
        element: <UnApprovedParticipations />,
      },
      {
        path: '/revoked-participations',
        element: <RevokedParticipations />,
      },
      {
        path: '/mandates',
        element: <Mandates />,
      },
      {
        path: '/manage-participations',
        element: <ManageParticipations />,
      },
      {
        path: '/manage-purposes',
        element: <ManagePurposes />,
      },
      {
        path: '/KLWResultatenOpties/Index/:klwId',
        element: <RapportageDashboard />,
      },
      {
        path: '/rapportage/historisch/Index',
        element: <HistorischRapportageDashboard />,
      },
      {
        path: '/beheer/rapportage',
        element: <BeheerRapportage />,
      },
      {
        path: '/dataproducten',
        element: <DataproductenHome />,
      },
      {
        path: '/beheer/pilot',
        element: <PilotBeheerHome />,
      },
      {
        path: '/importberichten-opnieuw-verwerken',
        element: <ImportberichtenOpnieuwVerwerken />,
      },
      {
        path: '/beheer/algemeen',
        element: <BeheerAlgemeen />,
      },
      {
        path: '/beheer/datakoppelingen',
        element: <BeheerDataKoppelingen />,
      },
      {
        path: '/bodem/overzicht/Index/:klwId',
        element: <BodemOverzicht />,
      },
      {
        path: '/bodem/overig/Index/:klwId',
        element: <BodemOverig />,
      },
      {
        path: '/bodem/analyses/Index/:klwId',
        element: <BodemAnalyses />,
      },
      {
        path: '/bodem/percelenoverzicht/Index/:klwId',
        element: <PercelenOld />,
      },
      {
        path: '/bodem/percelen/Index/:klwId',
        element: <Percelen />,
      },
      {
        path: '/bodem/percelen-op-kaart/Index/:klwId',
        element: <PercelenOpKaartPage />,
      },
      {
        path: '/percelenAkkerbouw/Index/:klwId',
        element: <AkkerbouwPage />,
      },
      {
        path: '/akkerbouw/Index/:klwId',
        element: <AkkerbouwPage />,
      },
      {
        path: '/bedrijfsgegevens/Index/:klwId',
        element: <BedrijfsGegevens />,
      },
      {
        path: '/Deelnemers',
        element: <Deelnemers />,
      },
      {
        path: '/Profiel/Index',
        element: <Profiel />,
      },
      {
        path: '/Relatie/Index',
        element: <RelatieStatus />,
      },
      {
        path: '/melklevering/Index/:klwId',
        element: <MelkLevering />,
      },
      {
        path: '/intensieveVeehouderij/Index/:klwId',
        element: <Intensief />,
      },
      {
        path: '/veestapelIenR/Index/:klwId',
        element: <JongveePage />,
      },
      {
        path: '/sbDashboard',
        element: <SBDashboard />,
      },
      {
        path: '/beheer/berichtstromen-beheren',
        element: <BerichtstromenBeheren />,
      },
      {
        path: '/OrganischeMeststromen/Index/:klwId',
        element: <Meststromen />,
      },
      {
        path: '/OrganischeMestVergistingScheiding/Index/:klwId',
        element: <OrganischeMest />,
      },
      {
        path: '/OrganischeMestVerbruik/Index/:klwId',
        element: <OrganischeMestVerbruik />,
      },
      {
        path: '/mestadditief/Index/:klwId',
        element: <MestAdditief />,
      },
      {
        path: '/Kunstmest/Index/:klwId',
        element: <Kunstmest />,
      },
      {
        path: '/KunstmestVerbruik/Index/:klwId',
        element: <KunstmestVerbruik />,
      },
      {
        path: '/voer',
        children: [
          {
            path: 'overig/index/:klwId',
            element: <Ruwvoer />,
          },
          {
            path: 'melkproducten/index/:klwId',
            element: <Melk />,
          },
          {
            path: 'grasland/index/:klwId',
            element: <Grasland />,
          },
          {
            path: 'snijmais/index/:klwId',
            element: <Snijmais />,
          },
          {
            path: 'strooisel/index/:klwId',
            element: <Strooisel />,
          },
          {
            path: 'overige/index/:klwId',
            element: <Overige />,
          },
          {
            path: 'krachtvoer/index/:klwId',
            element: <Krachtvoer />,
          },
        ],
      },
      {
        path: '/signalering/Index/:klwId',
        element: <Signaleringen />,
      },
      {
        path: '/Koppelingen/Index/:klwId',
        element: <Koppelingen />,
      },
      {
        path: '/registratie/relatie',
        element: <RelatieRegistratie />,
      },
      {
        path: '/Energie/Index/:klwId',
        element: <Energie />,
      },
      {
        path: '/EnergieTransacties/Index/:klwId',
        element: <EnergieTransacties />,
      },
      {
        path: '/Brokers',
        element: <Broker />,
      },
      {
        path: '/KengetallenGrafisch/Index/:klwId',
        element: <BVROverzicht />,
      },
      {
        path: '/KengetallenGrafisch/eiwiteigenland/:klwId',
        element: <BVREiwitEigenLand />,
      },
      {
        path: '/KengetallenGrafisch/ammoniak/:klwId',
        element: <BVRAmmoniak />,
      },
      {
        path: '/KengetallenGrafisch/broeikasgassenmeetmelk/:klwId',
        element: <BVRBroeikasgassenMeetmelk />,
      },
      {
        path: '/KengetallenGrafisch/stikstofbodemoverschot/:klwId',
        element: <BVRStikstofBodemOverschot />,
      },
      {
        path: '/KengetallenGrafisch/eiwitkvem/:klwId',
        element: <BVRRuwEiwitPerKvem />,
      },
      {
        path: '/KengetallenGrafisch/eiwitinrantsoen/:klwId',
        element: <BVRRuwEiwitInRantsoen />,
      },
      {
        path: '/KengetallenGrafisch/krachtvoer/:klwId',
        element: <BVRKrachtvoerPerLMelk />,
      },
      {
        path: '/KengetallenGrafisch/bexvoordeel/:klwId',
        element: <BVRBexVoordeel />,
      },
      {
        path: '/KengetallenGrafisch/broeikasgassenbedrijf/:klwId',
        element: <BVRBroeikasgassenPerBedrijf />,
      },
      {
        path: '/KengetallenGrafisch/veestapel/:klwId',
        element: <BVRVeestapel />,
      },
      {
        path: '/KengetallenGrafisch/grondengewassen/:klwId',
        element: <BVRGrondEnGewassen />,
      },
      {
        path: '/KengetallenTool',
        element: <KengetallenTool />,
      },
    ],
  },
]);

export const AppRouter: React.FunctionComponent = () => {
  return <RouterProvider router={router} />;
};
